export default __webpack_public_path__ + "static/media/Analytics (Real Size).4a794074.svg";